var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmployeeAttendancePageControl',{on:{"downloadClicked":_vm.download,"refreshClicked":_vm.refresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }